module.exports = __webpack_public_path__ + "public/img/guoqi262.da609a52.png";